<template>
  <div class="swan-quality-inspection">
    <a-tabs type="card" v-model:activeKey="tabActivekey">
      <template v-for="item in PQCProductOption" :key="item.value">
        <a-tab-pane :tab="item.label">
          <three-pieced :deleteAuthority="meta" :type="item.value" v-if="tabActivekey === item.value"></three-pieced>
        </a-tab-pane>
      </template>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, watch, provide } from "vue";
import { useRoute } from "vue-router";
import iqc from "../../components/product/IQC/index.vue";
import threePieced from "../../components/product/threePieced/index.vue";
import referenceArm from "../../components/product/referenceArm/index.vue";
import completeReferenceArm from "../../components/product/completeReferenceArm/index.vue";
import tasks from "../../components/product/organizingTasks/index.vue";
import calibrate from "../../components/product/calibrate/index.vue";
import assembleDebug from "../../components/product/assembleDebug/index.vue";
import oqc from "../../components/product/OQC/index.vue";
import fqc from "../../components/product/FQC/index.vue";
import instruction from "../../components/instruction/index.vue";
import inventorysf from "@/views/productDaily/components/product/components/inventorySF";

import { getPQCProductOption } from "@/views/productDaily/serve/option";

export default defineComponent({
  components: {
    threePieced,
  },
  setup() {
    const tabActivekey = ref(null);

    provide("tabActivekey", tabActivekey);

    const produceOrTpc = ref(null);

    provide("produceOrTpc", produceOrTpc);

    const PQCProductOption = getPQCProductOption().filter(
      (f) =>
        f.label !== "束腰" &&
        f.label !== "绕光纤参考臂" &&
        f.label !== "成品" &&
        f.label !== "包装"
    );

    const route = useRoute();

    const meta = reactive({
      "deleteAbnormalProblemHandle": false,
      "deleteCapacitySpotCheck": false,
      "deleteProcessChange": false,
      "deleteQualitySpotCheck": false,
      "deleteStationCheck": false,
      "eleteWIRecord": false,
      "edit_components_tasks": false,
    });

    watch(
      () => route.query,
      (val) => {
        if (val.meta) {
          const authority = JSON.parse(decodeURI(val.meta));
          Object.keys(authority).forEach((key) => {
            const checkKey = String(key).replace('/trail_', '').replace('/product_', '');
            meta[checkKey] = authority[key];
          });
          produceOrTpc.value = authority.produceOrTpc;
          tabActivekey.value = null;

          console.log(authority, meta, '传过来的权限是什么');
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      tabActivekey,
      meta,
      PQCProductOption,
    };
  },
});
</script>

<style lang="less">
.swan-quality-inspection {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
}

.product-section {
  border-radius: 20px;
  box-shadow: 0 0 10px 0 #ccc;
  padding: 20px 0;
  width: calc(100% - 60px);
  margin: 20px auto;

  .title {
    font-size: 20px;
    font-weight: bold;
  }
}

.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>
